import { render, staticRenderFns } from "./BannerInfo.vue?vue&type=template&id=3bb6eb1b&scoped=true&"
import script from "./BannerInfo.vue?vue&type=script&lang=js&"
export * from "./BannerInfo.vue?vue&type=script&lang=js&"
import style0 from "./BannerInfo.vue?vue&type=style&index=0&id=3bb6eb1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6eb1b",
  null
  
)

export default component.exports